import React from 'react';
import false_icon from '../../../assets/icons/false.svg';
import true_icon from '../../../assets/icons/true.svg';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatMonthDayTime } from 'config/time';
import { buttonLike } from 'reusable/buttonLike';
import DeviceTimeZone, { deviceTimeZoneOf } from 'reusable/DeviceTimeZone';

interface InspectionRecordProps {
  inspectionRecord: any[];
}

const VehicleInspectionRecordTable: React.FC<InspectionRecordProps> = ({
  inspectionRecord,
}) => {
  const { t, i18n } = useTranslation('vehicle');
  const navigate = useNavigate();

  const handleRowClick = (recordId: string) => {
    navigate(`/vehicle/${recordId}`);
  };
  const checkEngineStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const enginePart = record.details.vehicle_part.find(
        (part: any) => part.name === 'Engine' || part.name === 'エンジン'
      );
      if (enginePart) {
        // console.log(enginePart.item.every((item: any) => item.status === true), enginePart);
        return enginePart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };

  const checkLightStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const lightPart = record.details.vehicle_part.find(
        (part: any) =>
          part.name === 'Lighting/Blinker' ||
          part.name === '照明装置/方向指示器'
      );
      if (lightPart) {
        // console.log(lightPart.item.every((item: any) => item.status === true), lightPart);
        return lightPart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };

  const checkTireStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const tirePart = record.details.vehicle_part.find(
        (part: any) => part.name === 'Tire' || part.name === 'タイヤ'
      );
      if (tirePart) {
        // console.log(tirePart.item.every((item: any) => item.status === true), tirePart);
        return tirePart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };

  const checkBatteryStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const batteryPart = record.details.vehicle_part.find(
        (part: any) => part.name === 'Battery' || part.name === 'バッテリー'
      );
      if (batteryPart) {
        // console.log(batteryPart.item.every((item: any) => item.status === true), batteryPart);
        return batteryPart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };

  const checkAirTankStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const airTankPart = record.details.vehicle_part.find(
        (part: any) => part.name === 'Air Tank' || part.name === 'エアタンク'
      );
      if (airTankPart) {
        // console.log(airTankPart.item.every((item: any) => item.status === true), airTankPart);
        return airTankPart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };

  const checkBreakStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const brakePart = record.details.vehicle_part.find(
        (part: any) => part.name === 'Brake' || part.name === 'ブレーキ'
      );
      if (brakePart) {
        // console.log(brakePart.item.every((item: any) => item.status === true), brakePart);
        return brakePart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };

  const checkWindowWiperStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const windowWasherPart = record.details.vehicle_part.find(
        (part: any) =>
          part.name === 'Window Washer Liquid' ||
          part.name === 'ウインドウォッシャー液'
      );
      if (windowWasherPart) {
        // console.log(windowWasherPart.item.every((item: any) => item.status === true), windowWasherPart);
        return windowWasherPart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };

  const checkWipertStatus = (record: any) => {
    if (record.details && record.details.vehicle_part) {
      const wiperPart = record.details.vehicle_part.find(
        (part: any) => part.name === 'Wiper' || part.name === 'ワイパー'
      );
      if (wiperPart) {
        // console.log(wiperPart.item.every((item: any) => item.status === true), wiperPart);
        return wiperPart.item.every((item: any) => item.status === true);
      }
    }
    return null;
  };
  return (
    <section className="flex flex-col space-y-1">
      <div className="flex flex-row bg-primary/50 rounded-md py-3 px-4 items-center">
        {/* 2026-11-04。日時（10/31 08:22:00）とナンバー（品川 500 あ 00-02）はほかの列（✓）より長いので、
            この2列だけ 1.5 倍の幅にし、折らない（同じ幅だと日時がナンバーの列を押していた）。 */}
        <h6 className="flex-[1.5] whitespace-nowrap">
          {t('inspection-record.table.inspection-date')}
        </h6>
        <h6 className="flex-[1.5] text-center whitespace-nowrap">
          {t('inspection-record.table.plate-number')}
        </h6>
        <h6 className="flex-1 text-center">
          {t('inspection-record.table.engine')}
        </h6>
        <h6 className="flex-1 text-center">
          {t('inspection-record.table.lighting')}
        </h6>
        <h6 className="flex-1 text-center">
          {t('inspection-record.table.tire')}
        </h6>
        <h6 className="flex-1 text-center">
          {t('inspection-record.table.battery')}
        </h6>
        <h6 className="flex-1 text-center">
          {t('inspection-record.table.air-tank')}
        </h6>
        <h6 className="flex-1 text-center">
          {t('inspection-record.table.brake')}
        </h6>
        {/* A28。列名は短く「WW液」。正式な名前は title と読み上げで伝える。 */}
        <h6 className="flex-1 text-center whitespace-nowrap">
          <abbr title={t('inspection-record.table.window-washer-liquid-full')} className="no-underline">
            {t('inspection-record.table.window-washer-liquid')}
          </abbr>
        </h6>
        <h6 className="flex-1 text-center">
          {t('inspection-record.table.wiper')}
        </h6>
        <h6 className="flex-1 text-right">
          {t('inspection-record.table.inspection-by')}
        </h6>
        <h6 className="flex-1 text-right">
          {t('time-zone.device', { ns: 'common' })}
        </h6>
        <h6 className="flex-1 text-right">
          {t('inspection-record.table.details')}
        </h6>
      </div>
      {inspectionRecord.map((record) => (
        <div
          key={record.id}
          className="flex flex-row items-center justify-between border-b px-4 cursor-pointer"
          {...buttonLike(() => handleRowClick(record.id))}
        >
          {/* 点検日は日本時間の業務日。UTC の日付を切り出すと 0〜9時の点検が前日になる。
              A28。日付は折らない（「2026-10-」と「31」に分かれていた）。
              2026-11-04 PM。月で送る表なので年を出さず、日時（月日 時分秒。会社の時間帯）にする。 */}
          <p className="flex-[1.5] py-4 whitespace-nowrap">{formatMonthDayTime(record.create_time)}</p>
          <p className="flex-[1.5] text-center whitespace-nowrap">{record.vehicle.plate_number}</p>
          <p className="flex-1 flex justify-center">
            {checkEngineStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkEngineStatus(record) ? true_icon : false_icon}
                alt={checkEngineStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          <p className="flex-1 flex justify-center">
            {checkLightStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkLightStatus(record) ? true_icon : false_icon}
                alt={checkLightStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          <p className="flex-1 flex justify-center">
            {checkTireStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkTireStatus(record) ? true_icon : false_icon}
                alt={checkTireStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          <p className="flex-1 flex justify-center">
            {checkBatteryStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkBatteryStatus(record) ? true_icon : false_icon}
                alt={checkBatteryStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          <p className="flex-1 flex justify-center">
            {checkAirTankStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkAirTankStatus(record) ? true_icon : false_icon}
                alt={checkAirTankStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          <p className="flex-1 flex justify-center">
            {checkBreakStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkBreakStatus(record) ? true_icon : false_icon}
                alt={checkBreakStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          {/* A28。見出しと同じ順（ウインドウォッシャー液 → ワイパー）。以前は行だけ逆で、列の値が入れ替わって見えていた。 */}
          <p className="flex-1 flex justify-center">
            {checkWindowWiperStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkWindowWiperStatus(record) ? true_icon : false_icon}
                alt={checkWindowWiperStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          <p className="flex-1 flex justify-center">
            {checkWipertStatus(record) === null ? (
              '-'
            ) : (
              <img
                className="h-8"
                src={checkWipertStatus(record) ? true_icon : false_icon}
                alt={checkWipertStatus(record) ? t('ui.check-ok', { ns: 'common' }) : t('ui.check-ng', { ns: 'common' })}
              />
            )}
          </p>
          <p className="flex-1 text-right">{record.user.name}</p>
          {/* EV-116 段階3。送信の時点の端末の時間帯。 */}
          <DeviceTimeZone className="flex-1 text-right" {...deviceTimeZoneOf(record)} at={record.create_time} />
          <p className="flex-1 text-right underline text-blue-600">
            {t('inspection-record.table.detail_button')}
          </p>
        </div>
      ))}
    </section>
  );
};

export default VehicleInspectionRecordTable;
